import * as React from 'react';
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {addCommas, handleSetQuery, HandlerShowMessage, handleScrollIntoView, removeNonNumeric, HandleValidationMethod, handleBorderColor} from "../../assets/js/main";
import {Box, Checkbox, CircularProgress, FormControlLabel, FormGroup} from "@mui/material";
import NavBar from "../../components/NavBar";
import {PatternFormat} from "react-number-format";
import {setLoading} from "../../redux/loading/actions";
import HandleFetchData from "../../plugin/HandleFetchData";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {setValidations} from "../../redux/public/actions";


export default function WithdrawalRequest(props) {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {fetchData} = HandleFetchData()
  const {showMessage} = HandlerShowMessage();
  const {validationMethod} = HandleValidationMethod()

  const fullNameRef = React.useRef()
  const phoneRef = React.useRef()
  const ibanNumberRef = React.useRef()
  const priceRef = React.useRef()

  const selector = useSelector((st) => st)
  const [fullName, setFullName] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [ibanNumber, setIbanNumber] = React.useState('');
  const [price, setPrice] = React.useState('');


  const validationInput = (event) => {
    event.preventDefault();

    if(!fullName){
      validationMethod(fullNameRef, 'fullName', t("error.t4"))
    }else if(!phone){
      validationMethod(phoneRef, 'phone', t("error.t6"))
    } else if (phone?.length !== 11 || !phone.startsWith("09")) {
      validationMethod(phoneRef, 'phone', t("error.t7"))
    }else if(!ibanNumber){
      validationMethod(ibanNumberRef, 'ibanNumber', t("error.t43"))
    }else if(!price){
      validationMethod(priceRef, 'price', t("error.t44"))
    }else{
      handleSubmit()
    }
  }


  const handleSubmit = async () => {
    dispatch(setValidations(null))
    dispatch(setLoading(true))
    let fetch = await fetchData('ticketing', 'POST', '/v1/Withdrawal', {
         "ticketId": 0,
         "fullName": fullName,
         "mobileNumber": phone,
         "iBan": "IR"+ibanNumber,
         "amount": Number(price?.split(',').join(''))
       },
       "application/json",'', 'postex'
    )
    showMessage(fetch?.status)
    if(fetch?.success){
        navigate({
          pathname: "/wallet",
          search: location?.search
        });
    }
    dispatch(setLoading(false))
  }

  return (
     <>
       <NavBar blue back/>

       <div className="container">
         <div className="withdrawalRequestPage">
           <div className="titlePage">
             <h1>{t("withdrawalRequest.t1")}</h1>
             <p>{t("withdrawalRequest.t2")}</p>
             <p>{t("withdrawalRequest.t3")}</p>
             <p>{t("withdrawalRequest.t4")}</p>
             <p>{t("withdrawalRequest.t5")}</p>
           </div>


           <div className="form">
             <form onSubmit={validationInput}>
               <div className="row">
                 <div className="col-12 col-md-6">
                   <div className="input">
                     <label>{t("withdrawalRequest.t6")}</label>
                     <input type="text" name="fullName" id="fullName"
                            style={handleBorderColor(selector?.public?.validations?.fullName)}
                            value={fullName} ref={fullNameRef}
                            onChange={e => setFullName(e.target.value)}/>
                     {
                       selector?.public?.validations?.fullName &&
                       <p className="error">{selector?.public?.validations?.fullName}</p>
                     }
                   </div>
                 </div>
                 <div className="col-12 col-md-6">
                   <div className="input">
                     <label>{t("withdrawalRequest.t7")}</label>
                     <input type="text" name="phone" className="numeric" inputMode='numeric' id="phone"
                            style={handleBorderColor(selector?.public?.validations?.phone)}
                            value={phone} ref={phoneRef}
                            onChange={e => setPhone(removeNonNumeric(e.target.value))}/>
                     {
                       selector?.public?.validations?.phone &&
                       <p className="error">{selector?.public?.validations?.phone}</p>
                     }
                   </div>
                 </div>
                 <div className="col-12 col-md-6">
                   <div className="input">
                     <label>{t("withdrawalRequest.t8")}</label>
                     <PatternFormat name="iban" id="iban" value={ibanNumber} valueIsNumericString
                                    format="IR## #### #### #### #### #### ##" ref={ibanNumberRef}
                                    onValueChange={(value) => setIbanNumber(value?.value)}
                                    style={{direction: 'ltr'}}/>
                     {
                       selector?.public?.validations?.ibanNumber &&
                       <p className="error">{selector?.public?.validations?.ibanNumber}</p>
                     }
                   </div>
                 </div>
                 <div className="col-12 col-md-6">
                   <div className="input">
                     <label>{t("withdrawalRequest.t9")}</label>
                     <input type="text" autoComplete="on" id="price" inputMode='numeric' value={price} ref={priceRef} style={handleBorderColor(selector?.public?.validations?.price)}
                            onChange={e => setPrice(addCommas(removeNonNumeric(e.target.value)))}/>
                     {
                       selector?.public?.validations?.price &&
                       <p className="error">{selector?.public?.validations?.price}</p>
                     }
                   </div>
                 </div>
                 <div className="col-12">
                   <div className="btnGroup_yellow mb-0">
                     <button type="submit" className="btnFill justify-content-center m-0" disabled={selector?.loading?.isLoading}>
                       {
                         selector?.loading?.isLoading ?
                            <Box sx={{display: 'flex'}}>
                              <CircularProgress size={20}/>
                            </Box>
                            :
                            <span>{t("withdrawalRequest.t10")}</span>
                       }
                     </button>
                   </div>
                 </div>
               </div>
             </form>
           </div>
         </div>
       </div>
     </>
  )
}
